var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCircleCheck(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 11,
    viewBox: "0 0 12 11",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.15246 3.78635L5.52009 6.05006L4.84711 5.11619L4.84698 5.11602C4.75227 4.98501 4.60024 4.90546 4.43635 4.90546H3.91291C3.71788 4.90546 3.6051 5.12649 3.71846 5.2846L3.7187 5.28493L5.10906 7.21313C5.10909 7.21317 5.10912 7.21321 5.10915 7.21325C5.15587 7.27843 5.21745 7.33153 5.28878 7.36818C5.36016 7.40485 5.43925 7.42397 5.5195 7.42397C5.59974 7.42397 5.67883 7.40485 5.75021 7.36818C5.82154 7.33154 5.8831 7.27844 5.92983 7.21328C5.92986 7.21323 5.9299 7.21318 5.92994 7.21313L8.27927 3.95574C8.27944 3.95551 8.27961 3.95527 8.27978 3.95503C8.39571 3.79638 8.28163 3.5751 8.08702 3.5751H7.56358C7.40203 3.5751 7.24816 3.65258 7.15267 3.78605C7.1526 3.78615 7.15253 3.78625 7.15246 3.78635ZM6 0.35C3.156 0.35 0.85 2.656 0.85 5.5C0.85 8.344 3.156 10.65 6 10.65C8.844 10.65 11.15 8.344 11.15 5.5C11.15 2.656 8.844 0.35 6 0.35ZM6 9.50179C3.79043 9.50179 1.99821 7.70957 1.99821 5.5C1.99821 3.29043 3.79043 1.49821 6 1.49821C8.20957 1.49821 10.0018 3.29043 10.0018 5.5C10.0018 7.70957 8.20957 9.50179 6 9.50179Z",
    fill: "#027A48",
    stroke: "#027A48",
    strokeWidth: 0.3
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCircleCheck);
export default __webpack_public_path__ + "static/media/circle_check.003f845a87ab3f1f0517a2040e9ace2f.svg";
export { ForwardRef as ReactComponent };